import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Row, Col } from "react-bootstrap";
import Modal from "react-modal";
import LeadLogsTable from "../LeadLogsTable";
import LeadFilters from "../LeadFilters";
import CommonAddLeadbtns from "../CommonAddLeadbtns";
import ConvertedLeads from "../converted-leads/ConvertedLeads";
import RawLeadLogs from "../raw-lead/RawLeadLogs";
import ReactVortoxSpinner from "../../common-components/ReactVortoxSpinner";
import ModalHeadAndClose from "../../payouts-wtf/common/ModalHeadAndClose";
import {
  fetchAllLeadsData,
  fetchLeadValuesConvertedData,
  fetchLeadsStatsData,
  fetchRawLeadStatsData,
  fetchRawLeadsData,
} from "../../../redux/reducers/apiSlice";
import { currentMonthCurrentDate } from "../../common-data/Converts";
import UnassignedLeads from "../raw-lead/UnassignedLeads";
import ODMTabs from "../../odm/ODMTabs";
import BTLLeads from "../../btl-leads/BTLLeads";
import { isManagerRole as checkIsManagerRole } from "../../common-data/Conversions";

const LeadLandingCommon = ({ userInfoData, isCustom }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const tableRef = useRef(null);
  const mobileTableRef = useRef(null);

  const { allLeads, leadValuesConverted, leadValuesConvertedLoading } =
    useSelector((state) => state.api);

  const isAdmin = userInfoData?.account_type === "admin";
  const isGym = userInfoData?.account_type === "gym";
  const isMarketing = userInfoData?.account_type === "marketing";
  const isManagerRole = checkIsManagerRole(userInfoData);

  const [isPage, setIsPage] = useState(0);
  const [pageLimit, setPageLimit] = useState(10);
  const iniAllFilter = {
    selectedGym:
      isGym || (!isAdmin && !isMarketing && !isManagerRole)
        ? {
            label: isGym ? userInfoData?.name : userInfoData?.gym_name || "",
            value:
              userInfoData?.gym_id ||
              userInfoData?.user_id ||
              userInfoData?.uid ||
              "",
          }
        : "",
    selAddedby: "",
    selAssignee:
      !isAdmin && !isMarketing && !isManagerRole
        ? {
            label: userInfoData?.name || "",
            value: userInfoData?.uid || userInfoData?.user_id || "",
          }
        : "",
    selectedAssigneeStatus: "",
    selLeadStatus: "",
    selCustomerIntent: "",
    selFollowupStatus: "",
    selLeadSource: "",
    selUTMSource: "",
    selectedVendor: "",
    selCard: "",
    setPlan: "",
    selFollowupTime: [],
    selIsRaw: "",
    selLeadFrom: "",
    selFollowupStage: "",
    selOperatorValue: "",
    selConvertedIn: [],
    clickedCard: "",
    selectedWhatsappVerification: "",
    searchString: "",
    leadAddDateFrom: "",
    leadAddDateTo: "",
    leadFollowupDateFrom: "",
    leadFollowupDateTo: "",
    leadLastFollowupDateFrom: "",
    leadLastFollowupDateTo: "",
    leadClosureDateFrom: "",
    leadClosureDateTo: "",
    leadConvertedDateFrom: "",
    leadConvertedDateTo: "",
    rawLeadAddDateFrom: "",
    rawLeadAddDateTo: "",
    isToggledValue: false,
  };
  const [allFilters, setAllFilters] = useState(iniAllFilter);
  const iniFilters = {
    page: isPage + 1,
    limit: pageLimit || 10,
    filter_type: allFilters.clickedCard ? allFilters.clickedCard : "all",
    gym_id: allFilters.selectedGym?.value || "",
    assigned_to: allFilters.selAssignee?.value || "",
    assignee_deleted: allFilters.selectedAssigneeStatus?.value || "",
    added_by: allFilters.selAddedby?.value || "",
    lead_status: allFilters.selLeadStatus?.value || "",
    follow_up_status: allFilters.selFollowupStatus?.value || "",
    source_name: allFilters.selLeadSource?.value || "",
    utm_source: allFilters.selUTMSource?.value || "",
    btl_vendor_id: allFilters.selectedVendor?.value || "",
    lead_type: allFilters.selCard?.value || "",
    intent_id: allFilters.selCustomerIntent?.value || "",
    plan_type: allFilters.setPlan?.value || "",
    is_raw_lead: allFilters.selIsRaw?.value || "",
    wap_image: allFilters.selectedWhatsappVerification?.value || "",
    date_from: allFilters.leadAddDateFrom || "",
    date_to: allFilters.leadAddDateTo || "",
    followup_date_start: allFilters.leadFollowupDateFrom || "",
    followup_date_end: allFilters.leadFollowupDateTo || "",
    follow_up_date_from: allFilters.leadLastFollowupDateFrom || "",
    follow_up_date_to: allFilters.leadLastFollowupDateTo || "",
    expected_closure_date_from: allFilters.leadClosureDateFrom || "",
    expected_closure_date_to: allFilters.leadClosureDateTo || "",
    rawlead_start_date: allFilters.rawLeadAddDateFrom || "",
    rawlead_end_date: allFilters.rawLeadAddDateTo || "",
    operator_value: allFilters.selOperatorValue?.value || "",
  };
  const [filters, setFilters] = useState(iniFilters);
  const [isRawPage, setRawIsPage] = useState(0);
  const iniRawFilters = {
    limit: 10,
    page: isRawPage + 1,
    gym_id: filters.gym_id || "",
    added_by: filters.added_by || "",
    assigned_to: filters.assigned_to || "",
  };
  const [rawLeadFilters, setRawLeadFilters] = useState(iniRawFilters);
  const iniPTDatas = {
    isPage: 0,
    pagination: [],
    allLeads: [],
    stats_cards: {},
  };
  const [allDatas, setAllDatas] = useState(iniPTDatas);
  const [isConvertedModal, setIsConvertedModal] = useState(false);
  const iniRawLeads = {
    rawLeadStats: {},
    unassignedRawLeads: "",
    unassignedRawLeadsStats: {},
    allRawLeadData: [],
    rawLeadPagination: [],
    btlLeadsStats: null,
    watiLeadStats: {},
  };
  const [rawLeads, setRawLeads] = useState(iniRawLeads);

  function onCloseConvertedModal() {
    setIsConvertedModal(false);
    setAllFilters((prevs) => ({
      ...prevs,
      leadAddDateFrom: "",
      leadAddDateTo: "",
      leadFollowupDateFrom: "",
      leadFollowupDateTo: "",
      leadClosureDateFrom: "",
      leadClosureDateTo: "",
      selLeadStatus: "",
      selFollowupStatus: "",
      selLeadSource: "",
      selIsRaw: "",
      selCard: "",
      setPlan: "",
      clickedCard: "",
      searchString: "",
    }));
    setFilters((prevs) => ({
      ...prevs,
      page: 1,
      filter_type: "all",
      lead_status: "",
      source_name: "",
      is_raw_lead: "",
      date_from: "",
      date_to: "",
      expected_closure_date_from: "",
      expected_closure_date_to: "",
      lead_type: "",
      plan_type: "",
    }));
  }

  function getAllLeads(filters) {
    dispatch(
      fetchAllLeadsData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  function getLeadStats() {
    const filtersToSend = {
      gym_id: filters.gym_id,
      assigned_to: filters.assigned_to,
      added_by: filters.added_by,
    };

    dispatch(
      fetchLeadsStatsData({
        filters: filtersToSend,
        token: userInfoData?.token,
      })
    );
  }

  function getRawLeads(rawLeadFilters) {
    dispatch(
      fetchRawLeadsData({
        filters: rawLeadFilters,
        token: userInfoData?.token,
      })
    );
  }

  function getUnassignedRawLeads(rawLeadFilters) {
    const filtersToSend = {
      gym_id: rawLeadFilters.gym_id,
      assigned_to: rawLeadFilters.assigned_to,
      added_by: rawLeadFilters.added_by,
      is_lms: 1,
    };

    dispatch(
      fetchRawLeadStatsData({
        filters: filtersToSend,
        token: userInfoData?.token,
      })
    );
  }

  function getLeadConvertedData(filters) {
    const filtersToSend = {
      page: filters.page,
      limit: 10,
      gym_id: filters.gym_id,
      assigned_to: filters.assigned_to,
      added_by: filters.added_by,
      date_from:
        filters.filter_type === "lead_values_converted_today"
          ? currentMonthCurrentDate
          : "",
      date_to:
        filters.filter_type === "lead_values_converted_today"
          ? currentMonthCurrentDate
          : "",
    };

    dispatch(
      fetchLeadValuesConvertedData({
        filters: filtersToSend,
        token: userInfoData?.token,
      })
    );
  }

  function getComineReload() {
    getAllLeads(filters);
    getLeadStats();
    getRawLeads(rawLeadFilters);
    getUnassignedRawLeads(rawLeadFilters);
  }

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
      limit: pageLimit,
    }));
  }, [isPage, pageLimit]);

  useEffect(() => {
    setRawLeadFilters((prevs) => ({
      ...prevs,
      page: isRawPage + 1,
      gym_id: filters.gym_id || "",
      added_by: filters.added_by || "",
      assigned_to: filters.assigned_to || "",
    }));
  }, [
    isRawPage,
    filters.gym_id,
    filters.added_by,
    filters.assigned_to,
    userInfoData?.gym_id,
  ]);

  useEffect(() => {
    getLeadStats();
  }, [filters.gym_id, filters.assigned_to, filters.added_by, userInfoData]);

  useEffect(() => {
    if (
      filters.filter_type === "lead_values_converted" ||
      filters.filter_type === "lead_values_converted_today"
    ) {
      getLeadConvertedData(filters);
    }
  }, [
    filters.gym_id,
    filters.assigned_to,
    filters.added_by,
    filters.filter_type,
    filters.page,
  ]);

  useEffect(() => {
    getRawLeads(rawLeadFilters);
  }, [filters.filter_type, rawLeadFilters]);

  useEffect(() => {
    getUnassignedRawLeads(rawLeadFilters);
  }, [
    filters.filter_type,
    rawLeadFilters.gym_id,
    rawLeadFilters.added_by,
    rawLeadFilters.assigned_to,
  ]);

  useEffect(() => {
    if (
      filters.page &&
      filters.filter_type !== "lead_values_converted" &&
      filters.filter_type !== "lead_values_converted_today" &&
      filters.filter_type !== "customer_not_in_lms_but_paid" &&
      filters.filter_type !== "raw_leads" &&
      filters.filter_type !== "duplicate_leads" &&
      filters.filter_type !== "new_raw_leads" &&
      filters.filter_type !== "one_day_membership" &&
      filters.filter_type !== "BTL_leads" &&
      filters.filter_type !== "referral" &&
      filters.filter_type !== "wati_leads"
    ) {
      getAllLeads(filters);
    }
  }, [filters, userInfoData]);

  useEffect(() => {
    if (
      (filters.filter_type === "lead_values_converted" ||
        filters.filter_type === "lead_values_converted_today") &&
      leadValuesConverted?.status &&
      leadValuesConverted?.data?.length > 0 &&
      !leadValuesConvertedLoading
    ) {
      setAllDatas((prevs) => ({
        ...prevs,
        allLeads: leadValuesConverted.data,
        pagination:
          leadValuesConverted?.pagination?.length > 0
            ? leadValuesConverted.pagination
            : [],
      }));
    } else if (
      filters.filter_type !== "lead_values_converted" &&
      filters.filter_type !== "lead_values_converted_today" &&
      filters.filter_type !== "customer_not_in_lms_but_paid" &&
      filters.filter_type !== "raw_leads" &&
      filters.filter_type !== "duplicate_leads" &&
      filters.filter_type !== "new_raw_leads" &&
      filters.filter_type !== "one_day_membership" &&
      filters.filter_type !== "BTL_leads" &&
      filters.filter_type !== "referral" &&
      filters.filter_type !== "wati_leads" &&
      allLeads?.status &&
      allLeads?.data?.length > 0
    ) {
      setAllDatas((prevs) => ({
        ...prevs,
        allLeads: allLeads.data,
        pagination: allLeads?.pagination?.length > 0 ? allLeads.pagination : [],
        stats_cards: allLeads?.leadValues ? allLeads.leadValues : {},
      }));
    } else {
      setAllDatas({
        isPage: 0,
        pagination: [],
        allLeads: [],
        stats_cards: {},
      });
    }
  }, [allLeads, filters.filter_type, leadValuesConvertedLoading]);

  useEffect(() => {
    if (allFilters.isToggledValue) {
      navigate("/lms-beta", { replace: true });
    }
  }, [allFilters.isToggledValue]);

  return (
    <div className="w-100 h-auto position-relative">
      <Modal
        isOpen={isConvertedModal}
        onRequestClose={onCloseConvertedModal}
        contentLabel="Converted Leads Modal"
        ariaHideApp={false}
      >
        <div className={`createNewCTOModalContainer`}>
          <ModalHeadAndClose
            title={`${
              filters.filter_type === "one_day_membership"
                ? ""
                : filters.filter_type?.replace(/_/g, " ")
            }`}
            onClose={onCloseConvertedModal}
          />

          {leadValuesConvertedLoading ? (
            <ReactVortoxSpinner />
          ) : (
            <>
              {filters.filter_type === "lead_values_converted" ||
              filters.filter_type === "lead_values_converted_today" ? (
                <ConvertedLeads
                  allDatas={allDatas}
                  isPage={isPage}
                  setIsPage={setIsPage}
                />
              ) : filters.filter_type === "customer_not_in_lms_but_paid" ? (
                <RawLeadLogs
                  allData={rawLeads}
                  isPage={isRawPage}
                  setIsPage={setRawIsPage}
                  userInfoData={userInfoData}
                  onReload={() => getComineReload(filters)}
                />
              ) : filters.filter_type === "raw_leads" ||
                filters.filter_type === "duplicate_leads" ||
                filters.filter_type === "new_raw_leads" ||
                filters.filter_type === "referral" ||
                filters.filter_type === "wati_leads" ? (
                <UnassignedLeads
                  userInfoData={userInfoData}
                  prevAllFilters={allFilters}
                />
              ) : filters.filter_type === "one_day_membership" ? (
                <ODMTabs userInfoData={userInfoData} isFromLMS={true} />
              ) : filters.filter_type === "BTL_leads" ? (
                <BTLLeads
                  userInfoData={userInfoData}
                  prevAllFilters={allFilters}
                />
              ) : null}
            </>
          )}
        </div>
      </Modal>

      <Row>
        <Col>
          <CommonAddLeadbtns
            userInfoData={userInfoData}
            isCustom={isCustom}
            isAddBtn={!isMarketing ? true : false}
            onReload={() => getComineReload(filters)}
          />
        </Col>
      </Row>

      <LeadFilters
        userInfoData={userInfoData}
        allFilters={allFilters}
        setAllFilters={setAllFilters}
        iniAllFilter={iniAllFilter}
        filters={filters}
        setFilters={setFilters}
        tableRef={tableRef}
        mobileTableRef={mobileTableRef}
        setIsConvertedModal={setIsConvertedModal}
        isAdminView={true}
        rawLeads={rawLeads}
        setRawLeads={setRawLeads}
        setIsPage={setIsPage}
      />

      <Row>
        <Col>
          {filters.filter_type !== "lead_values_converted" &&
          filters.filter_type !== "lead_values_converted_today" &&
          filters.filter_type !== "customer_not_in_lms_but_paid" &&
          filters.filter_type !== "raw_leads" &&
          filters.filter_type !== "duplicate_leads" &&
          filters.filter_type !== "new_raw_leads" &&
          filters.filter_type !== "one_day_membership" &&
          filters.filter_type !== "BTL_leads" &&
          filters.filter_type !== "referral" &&
          filters.filter_type !== "wati_leads" &&
          !isConvertedModal ? (
            <LeadLogsTable
              userInfoData={userInfoData}
              allDatas={allDatas}
              setAllDatas={setAllDatas}
              isPage={isPage}
              setIsPage={setIsPage}
              pageLimit={pageLimit}
              setPageLimit={setPageLimit}
              callFunction={() => getComineReload(filters)}
              tableRef={tableRef}
              mobileTableRef={mobileTableRef}
              prevFilters={(({ limit, page, ...rest }) => rest)(filters)}
              isFollowupCount={
                filters?.followup_date_start && filters?.followup_date_end
              }
            />
          ) : null}
        </Col>
      </Row>
    </div>
  );
};

export default LeadLandingCommon;
